import { useEffect, useState } from "react"
import styled from "@emotion/styled"
import { Helmet } from "react-helmet-async"

import { useConsole } from "contexts/Console"
import { useDictionary } from "contexts/Dictionary"
import { useLocale } from "contexts/Locale"
import { useUser } from "contexts/User"
import { cssVarCurBanHeight } from "contexts/Header"

import { fullGrid } from "css/grid"
import { legend100 } from "css/text"
import getMediaQuery from "css/breakpoints"

import Button from "components/button/Button"
import LangDropDown from "./LangDropDown"

const Root = styled.div`
  position: relative;
  z-index: 10;
  width: 100%;
  height: var(${cssVarCurBanHeight});
  background: rgb(44 44 44);

  ${fullGrid}
  align-items: center;
  grid-template-rows: 10px 1fr 1fr;

  ${getMediaQuery("m")} {
    grid-template-rows: 1fr;
  }
`

const Para = styled.p`
  grid-column: 2 / span 5;
  grid-row: 2;
  ${legend100};
  align-self: end;
  margin-block-end: 5px;
  ${getMediaQuery("m")} {
    margin-block-end: unset;
    align-self: center;
    grid-row: 1;
    grid-column: 2 / span 4;
  }
`

const Close = styled(Button)`
  --btn-height: 2rem;
  grid-column: col 6;
  margin-inline-end: calc(var(--btn-height) / -2 + var(--grid-gap) / -2);

  grid-row: 2;
  align-self: start;
  justify-self: end;
  > svg {
    width: 10px !important;
    height: 10px !important;
  }

  ${getMediaQuery("m")} {
    margin-inline-end: unset;
    grid-row: 1;
    grid-column: col 13;
    justify-self: center;
    align-self: center;
  }
`

export default function CurrencyBanner() {
  const console = useConsole()
  const { currency_alert } = useLocale()
  const dictionary = useDictionary()
  const user = useUser()

  const isBanSess = process.browser && (sessionStorage.getItem("curban") === "true" || sessionStorage.getItem("curban") === null)

  const [isVisible, setIsVisible] = useState(user.displayCurrencyBanner && isBanSess)

  function onClose() {
    sessionStorage.setItem("curban", "false")
    setIsVisible(false)
    document.body.classList.remove("curban")
  }

  useEffect(() => {
    const isCurSess = sessionStorage.getItem("curban")
    if (isCurSess === null) {
      sessionStorage.setItem("curban", "true")
    } else if (isCurSess === "false") {
      setIsVisible(false)
    }
  }, [])

  return isVisible ? (
    <>
      <Helmet>
        <body className='curban' />
      </Helmet>
      <Root className='dark-theme'>
        <Para id='languageBannerText'>{currency_alert}</Para>
        <LangDropDown onClose={onClose} />
        <Close icon='close' className='icon translucent-light' onPress={onClose} aria_label={dictionary.close()}>
          <span>{dictionary.close()}</span>
        </Close>
      </Root>
    </>
  ) : null
}
